const userQueryKeys = {
  quota: (params) => [
    "user-quota",
    params
  ],
  userPreferences: () => [
    "user-preferences"
  ],
  userInfo: () => [
    "user-info"
  ]
};

export { userQueryKeys };
//# sourceMappingURL=userQueryKeys.js.map
